import { Link } from 'react-router-dom';
import { PanelTitle } from '@reflex/ui/components/layout/Typography';

export interface NavCardItem {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  description: string;
  details: string;
  features: readonly string[];
  /**
   * Optional stable hook for in-app tutorials. Mirrors the `data-tutorial-id`
   * the same nav item carries in the sidebar drill, so a tutorial can target
   * the card on a drill overview page (e.g. `/security`) regardless of whether
   * the sidebar drill panel happens to be open.
   */
  tutorialId?: string;
}

export function NavCardList({ items }: { items: readonly NavCardItem[] }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {items.map(({ to, label, icon: Icon, description, tutorialId }) => (
        <Link
          key={to}
          to={to}
          data-tutorial-id={tutorialId}
          className="group flex items-center gap-3 rounded-xl border border-border/30 bg-card/60 p-3 transition-all duration-200 hover:border-border/60 hover:bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-border/40">
            <Icon className="h-4 w-4 text-muted-foreground" />
          </div>
          <div className="min-w-0">
            <PanelTitle as="h2" size="sm">
              {label}
            </PanelTitle>
            <p className="mt-0.5 truncate text-xs text-muted-foreground">{description}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}
